<ng-container>
	<div class="hmf-display-lg-flex hmf-mb-xl hmf-mb-lg-xxl">
		<div *ngIf="isLoggedIn" id="myaccount-container" role="main" aria-label="My Account" class="hmf-display-lg-none hmf-flex-wrap">
			<div class="tab-group">
				<nav mat-tab-nav-bar disableRipple="true" [tabPanel]="routerOutlet" aria-label="nav-bar">
					<a mat-tab-link
						*ngFor="let tab of tabs"
						[routerLink]="tab.path"
						routerLinkActive #rla="routerLinkActive"
						[active]="rla.isActive"
						[title]="tab.label">
						{{tab.label}}
					</a>
					<a mat-tab-link class="tab-link" href="{{faqsLink}}" title="FAQ" (click)="analyticsClickEvent('ScoreCardFaqClick')">FAQ</a>
					<a mat-tab-link class="tab-link" [routerLink]="[]" (click)="signOut()" title="Sign Out" data-testid="sign-out">Sign Out</a>
				</nav>
			</div>
		</div>
		<ng-container *ngIf="isLoggedIn">
			<div class="side-nav-menu hmf-mt-l hmf-span-3 hmf-span-xlg-2 hmf-display-none hmf-display-lg-block hmf-pl-m">
				<div *ngIf="!personalInformation" class="member-info-skeleton">
					<div class="user-info">
						<span class="user-name hmf-header-bold-m hmf-mt-l">Welcome!</span>
					</div>
				</div>
				<div class="user-info" [hidden]="!personalInformation">
					<div>
						<span class="user-name hmf-header-bold-xl hmf-mt-l">{{ custName }}</span>
					</div>

					<div *ngIf="cardColor === 'gold'" class="score-card hmf-mt-xs">
						<div class="gold-card">
							<img src="assets/image/scorecard_gold_banner.svg" alt="ScoreCard Gold Banner" width="85px" height="18px">
						</div>
						<div class="member-info hmf-subheader-s hmf-mb-m hmf-mt-xxs">
							<div *ngIf="memberSince" class="hmf-mb-xxxs">
								<span class="hmf-subheader-bold-s">Member since: </span>
								<span>{{memberSince | date}}</span>
							</div>
							<div>
								<span class="hmf-subheader-bold-s">Gold earned: </span>
								<span>{{personalInformation.GoldSince | date}}</span>
							</div>
						</div>
					</div>
					<div *ngIf="cardColor === 'green'" class="score-card hmf-mt-xs">
						<div class="green-card">
							<img src="assets/image/scorecard_banner.svg" alt="ScoreCard Banner" width="61px" height="18px">
						</div>
						<div *ngIf="memberSince" class="member-info hmf-subheader-s hmf-mb-m hmf-mt-xxs">
							<span class="hmf-subheader-bold-s">Member since: </span>
							<span>{{ memberSince | date}}</span>
						</div>
					</div>

					<div *ngIf="cardColor === 'black'" class="score-card hmf-mt-xs">
						<div class="black-card">
							<img src="assets/image/scorerewards_banner.svg" alt="ScoreRewards Banner" width="80px" height="18px">
						</div>
						<div class="member-info hmf-subheader-s hmf-mb-m hmf-mt-xxs">
							<span class="hmf-subheader-bold-s">Card holder since: </span>
							<span>{{personalInformation.creditGoldSince | date}}</span>
						</div>
					</div>
				</div>
				<nav mat-tab-nav-bar disableRipple="true" disablePagination="true" class="fill-base" [tabPanel]="fillerMatTabNavPanel" aria-label="nav-bar">
					<div class="hmf-subheader-bold-m hmf-flex-grow">
						<ul class="hmf-pl-0 hmf-mb-s" [ngClass]="{'pl-border-top': isPublicLands}">
							<li [ngClass]="{'li-selected' : (selectedNavItem.indexOf('AccountSummary') > -1), 'pl-border-bottom': isPublicLands}" (click)="selectedNavItem='AccountSummary'">
								<a class="hmf-ml-xs hmf-py-s hmf-display-block" [routerLink]="['AccountSummary']" routerLinkActive="active">
									Summary
								</a>
							</li>
							<li [ngClass]="{'li-selected' : (selectedNavItem.indexOf('ScoreCard') > -1), 'pl-border-bottom': isPublicLands}" (click)="selectedNavItem='ScoreCard'">
								<a class="hmf-ml-xs hmf-py-s hmf-display-block" [routerLink]="['ScoreCard']" routerLinkActive="active">
									ScoreCard
									@if (rewardsCount && rewardsCount > 0) {
										<span class="rewards-badge hmf-ml-xxs hmf-p-xxxs hmf-soft-radius hmf-body-s">{{ rewardsCount | number: '2.0' }}</span>
									}
								</a>
							</li>
							<li [ngClass]="{'li-selected' : (selectedNavItem.indexOf('Orders') > -1), 'pl-border-bottom': isPublicLands}" (click)="selectedNavItem='Orders'">
								<a class="hmf-ml-xs hmf-py-s hmf-display-block" [routerLink]="['Orders']" routerLinkActive="active">
									Orders
								</a>
							</li>
							<li *ngIf="!listsEnabled" [ngClass]="{'li-selected' : (selectedNavItem.indexOf('Favorites') > -1), 'pl-border-bottom': isPublicLands}" (click)="selectedNavItem='Favorites'">
								<a class="hmf-ml-xs hmf-py-s hmf-display-block" [routerLink]="['Favorites']" routerLinkActive="active">
									Favorites
								</a>
							</li>
							<li *ngIf="listsEnabled" [ngClass]="{'li-selected' : (selectedNavItem.indexOf('Lists') > -1), 'pl-border-bottom': isPublicLands}" (click)="selectedNavItem='Lists'">
								<a class="hmf-ml-xs hmf-py-s hmf-display-block" [routerLink]="['Lists']" routerLinkActive="active">
									Lists
								</a>
							</li>
							<li *ngIf="eventReservationsEnabled" [ngClass]="{'li-selected' : (selectedNavItem.indexOf('Appointments') > -1), 'pl-border-bottom': isPublicLands}" (click)="selectedNavItem='Appointments'">
								<a class="hmf-ml-xs hmf-py-s hmf-display-block" [routerLink]="['Appointments']" routerLinkActive="active">
									Appointments
								</a>
							</li>
							<li class="outer-li-with-child" [ngClass]="{'pl-border-bottom': isPublicLands}">
								<div class="hmf-ml-xs hmf-pt-s hmf-pb-xxs">
									Profile
								</div>
								<ul class="nested-menu hmf-subheader-m hmf-pl-0 hmf-ml-xs hmf-pb-xs">
									<li class="nested-li hmf-pl-s" [ngClass]="{'li-selected' : (selectedNavItem.indexOf('PersonalInformation') > -1), 'pl-border-bottom': isPublicLands}">
										<a class="hmf-py-xxs hmf-display-block" [routerLink]="['PersonalInformation']" routerLinkActive="active"  (click)="selectedNavItem='PersonalInformation'">
											Personal Information
										</a>
									</li>
									<li class="nested-li hmf-pl-s" [ngClass]="{'li-selected' : (selectedNavItem.indexOf('Preferences') > -1), 'pl-border-bottom': isPublicLands}">
										<a class="hmf-py-xxs hmf-display-block" [routerLink]="['Preferences']" routerLinkActive="active"  (click)="selectedNavItem='Preferences'">
											Preferences
										</a>
									</li>
									<li class="nested-li hmf-pl-s" [ngClass]="{'li-selected' : (selectedNavItem.indexOf('Addresses') > -1), 'pl-border-bottom': isPublicLands}" (click)="selectedNavItem='Addresses'">
										<a class="hmf-py-xxs hmf-display-block" [routerLink]="['Addresses']" routerLinkActive="active">
											Addresses
										</a>
									</li>
									<li class="nested-li hmf-pl-s" [ngClass]="{'li-selected' : (selectedNavItem.indexOf('Settings') > -1), 'pl-border-bottom': isPublicLands}" (click)="selectedNavItem='Settings'">
										<a class="hmf-py-xxs hmf-display-block" [routerLink]="['Settings']" routerLinkActive="active">Settings</a>
									</li>
								</ul>
							</li>
						</ul>
						<hmf-button class="sign-out-btn hmf-mb-s"
							[variant]="'secondary'"
							[text]="'Sign Out'"
							[size]="'medium'"
							(click)="signOut()">
						</hmf-button>
						<div class="dsg-contact-info hmf-subheader-s">
							<p><strong>Customer Service</strong></p>
							<p>7 days a week | 8am&#8212;12am ET</p>
							<p></p>
							<div *ngIf="!goldStatus && !isPublicLands && !isGolfGalaxy" id="help-line" class="row text-center">
								<p class="help-line-phone hmf-pl-s"><a href="tel:+1-800-440-4002"> 1-800-440-4002</a></p>
							</div>
							<div *ngIf="goldStatus && !isPublicLands && !isGolfGalaxy" id="help-line" class="row text-center">
								<p class="help-line-phone hmf-pl-s"><a href="tel:+1-833-679-9638"> 1-833-679-9638</a></p>
							</div>
							<div *ngIf="isPublicLands" id="help-line" class="row text-center">
								<p class="help-line-phone hmf-pl-s"><a href="tel:+1-844-890-0896"> 1-844-890-0896</a></p>
							</div>
							<div *ngIf="isGolfGalaxy" id="help-line" class="row text-center">
								<p class="help-line-phone hmf-pl-s"><a href="tel:+1-800-287-9060"> 1-800-287-9060</a></p>
							</div>
							<p>Review our <a href="https://www.dickssportinggoods.com/s/scorecard-benefits" (click)="analyticsClickEvent('ScoreCardFaqClick')">FAQs</a> for quick help<br>
							or visit our <a href="https://www.dickssportinggoods.com/s/help-desk" (click)="analyticsClickEvent('HelpDeskClick')">help desk</a></p>
						</div>
					</div>
				</nav>
			</div>
		</ng-container>

		<div class="hmf-span-0 hmf-span-s-1 hmf-span-m-1" *ngIf="isLoggedIn"></div>

		<div class="main-content-bg hmf-span-12 hmf-span-lg-8 hmf-span-xlg-9 hmf-pb-sm-m hmf-flex-grow"
			[ngClass]="{
				'main-content green hmf-pt-l hmf-px-m hmf-pb-s': !isMobile,
				'content-area col-12 col-lg-10 hmf-py-s hmf-px-s hmf-pb-s': isMobile,
			}"
			>
			<ng-container *ngTemplateOutlet="routerOutlet"></ng-container>
		</div>


	</div>
</ng-container>

<ng-template #routerOutlet>
	<mat-tab-nav-panel>
		<router-outlet></router-outlet>
	</mat-tab-nav-panel>
</ng-template>

<mat-tab-nav-panel #fillerMatTabNavPanel></mat-tab-nav-panel>

<ng-template #loading_overlay>
	<div style="background-color: rgba(255,255,255,0.5);
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 500;">
		<common-progress-spinner
			diameter="50"
			class="loading-indicator"
			strokeWidth="5px">
		</common-progress-spinner>
	</div>
</ng-template>
